import React, { useState, useEffect } from "react";
import ReactPaginate from "react-paginate";
import { getRecordsText } from "utils/utils";
import "./Pagination.css";

const Pagination = ({
  itemsPerPage = 10,
  totalCount = 0,
  itemOffset = 0,
  listData = [],
  onPageChange = () => {},
  setItemOffset = () => {},
}) => {
  const [pageCount, setPageCount] = useState(2);

  useEffect(() => {
    const per = itemsPerPage > 0 ? itemsPerPage : 10;
    setPageCount(Math.max(1, Math.ceil((totalCount || 0) / per)));
  }, [totalCount, itemsPerPage]);

  const handlePageClick = (event) => {
    const newOffset = event.selected * 1;
    onPageChange(newOffset);
    setItemOffset(newOffset);
  };

  return (
    <div className="justo-pagination">
      <span className="justo-pagination__info">
        {getRecordsText(totalCount, itemOffset, itemsPerPage, listData.length)}
      </span>

      <ReactPaginate
        breakLabel="..."
        nextLabel={<i className="fa fa-chevron-right" />}
        previousLabel={<i className="fa fa-chevron-left" />}
        onPageChange={handlePageClick}
        pageCount={pageCount}
        forcePage={itemOffset}
        pageClassName="justo-pagination__page"
        pageLinkClassName="justo-pagination__link"
        previousClassName="justo-pagination__page justo-pagination__page--nav"
        previousLinkClassName="justo-pagination__link"
        nextClassName="justo-pagination__page justo-pagination__page--nav"
        nextLinkClassName="justo-pagination__link"
        breakClassName="justo-pagination__page"
        breakLinkClassName="justo-pagination__link"
        containerClassName="justo-pagination__list"
        activeClassName="justo-pagination__page--active"
        disabledClassName="justo-pagination__page--disabled"
      />
    </div>
  );
};

export default Pagination;
